module.exports = __webpack_public_path__ + "img/密码.59a8a6ab.svg";